'use strict';
require('../../../modules/es.array.last-index-of');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'lastIndexOf');
